import { mergeStyles } from '../../../../../internal/utils/mergeStyles';
import mainStyles from './styles.module.css';
import { getDeviceStyles, getDeviceStylesIdentity } from './device';
import { memoizeWith } from 'ramda';
function getSingleSelectItemStyles(deviceType) {
  const deviceStyles = getDeviceStyles(deviceType);
  return mergeStyles(mainStyles, deviceStyles);
}
export const getStyles = memoizeWith(getDeviceStylesIdentity, getSingleSelectItemStyles);